/**
 * Shared API utilities - auth via HttpOnly cookies (no token in headers).
 * Use buildHeaders() for all authenticated API calls.
 */

import { getConfig } from "./configUtils";

export function getBaseUrl(): string {
  const config = getConfig();
  return config?.API_URL || process.env.REACT_APP_API_URL || '';
}

export async function getCsrfToken(baseUrl?: string): Promise<string> {
  const url = baseUrl || getBaseUrl();
  const response = await fetch(`${url}/csrf/token`, {
    method: 'GET',
    credentials: 'include',
  });
  const data = await response.json();
  return data.csrfToken;
}

/**
 * Build headers for API requests (CSRF only; auth via HttpOnly cookies).
 * Pass baseUrl if the service uses its own config (e.g. from config.enc.json).
 */
export async function buildHeaders(baseUrl?: string): Promise<Record<string, string>> {
  const csrfToken = await getCsrfToken(baseUrl);
  return {
    'Content-Type': 'application/json',
    'X-CSRF-TOKEN': csrfToken,
  };
}

/**
 * Build headers for upload (FormData) requests. Do NOT set Content-Type so the browser
 * sets multipart/form-data with the correct boundary.
 */
export async function buildHeadersForUpload(baseUrl?: string): Promise<Record<string, string>> {
  const csrfToken = await getCsrfToken(baseUrl);
  return {
    'X-CSRF-TOKEN': csrfToken,
  };
}
